export const allOtas = ["bookingdotcom", "agoda", "goibibo", "yatra", "expedia", "booklogic"];
export const otasExceptBooklogic = ["bookingdotcom", "agoda", "goibibo", "yatra", "expedia"];
